import { RoleFeature } from '../../types/featureFlag'

export function AreRoleFeaturesDifferent(
  initial: RoleFeature[],
  temporary: RoleFeature[]
): boolean {
  const buildMap = (data: RoleFeature[]) => {
    const map = new Map<string, boolean>()

    for (let i = 0; i < data.length; i++) {
      const group = data[i]
      if (!group.features) continue

      for (let j = 0; j < group.features.length; j++) {
        const feature = group.features[j]
        map.set(feature.featureID, feature.selected)
      }
    }

    return map
  }

  const initialMap = buildMap(initial)
  const temporaryMap = buildMap(temporary)

  if (initialMap.size !== temporaryMap.size) {
    return true
  }

  // ✅ Use forEach instead of entries()
  let isDifferent = false

  initialMap.forEach((selected, featureID) => {
    if (!temporaryMap.has(featureID)) {
      isDifferent = true
      return
    }

    if (temporaryMap.get(featureID) !== selected) {
      isDifferent = true
    }
  })

  return isDifferent
}
